import React, { Component, Fragment } from 'react';
import throttle from 'lodash/throttle';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Toolbar, ToolbarIcon, ToolbarSection, ToolbarRow, ToolbarTitle } from 'rmwc/Toolbar';
import {
  TopAppBar,
  TopAppBarRow,
  TopAppBarSection,
  TopAppBarNavigationIcon,
  TopAppBarActionItem,
  TopAppBarTitle,
} from 'rmwc/TopAppBar';
import { Menu, MenuItem, MenuAnchor } from 'rmwc/Menu';
import Icon from 'rmwc/Icon';
import { Button } from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import Text from '../components/Text';
import Logo from '../components/Logo';
import { wlVar } from '../helpers/whitelabel';
import { screenSizes, headerHeightWide, headerHeightNarrow } from '../helpers/styleConstants';
import { newWindow } from '../helpers/newWindow';

import { signOutUser } from '../actions/userActions';

const PaddedLogo = styled.img`
  margin: 5px;
  vertical-align: bottom;
`;

const TopAppBarShim = styled.div`
  height: ${headerHeightWide}px;
  @media (max-width: 599px) {
    height: ${headerHeightNarrow}px;
  }
`;

export const topAppBarShimTop = css`
  top: ${headerHeightWide}px;
  @media (max-width: 599px) {
    top: ${headerHeightNarrow}px;
  }
`;

export class Header extends Component {
  state = {
    menuIsOpen: false,
    useMenuIcon: false,
  };

  // throttledHandleWindowResize = () => {
  //   return throttle(() => {
  //     this.updateWidth();
  //     console.log(Math.max(document.documentElement.clientWidth, window.innerWidth || 0), 'SIZE');
  //   }, 200);
  // };

  updateWidth = () => {
    this.setState({
      menuIsOpen: false,
      useMenuIcon:
        Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < screenSizes.tabletLandscapeUp,
    });
  };

  componentDidMount() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }

  render() {
    const isGuest = this.props.currentUser.is_guest;

    const { showSignIn, fixed } = this.props;

    // we only want the hamburger menu to show up when we are below a certain screen size
    // and when we have more than 1 link to display
    const numberOfLinks = [
      ...(wlVar('link_label_extra2') && wlVar('link_href_extra2') ? ['placeholder'] : []),
      ...(wlVar('link_label_extra1') && wlVar('link_href_extra1') ? ['placeholder'] : []),
      ...(wlVar('link_label_services') && wlVar('link_href_services') ? ['placeholder'] : []),
      ...(wlVar('link_label_consult') && wlVar('link_href_consult') ? ['placeholder'] : []),
    ].length;

    return (
      <Fragment>
        <TopAppBar
          fixed={fixed}
          style={{
            //...(fixed ? { boxShadow: 'none' } : {}),
            zIndex: '2',
            ...(wlVar('white_header')
              ? { backgroundColor: 'white', borderBottom: '1px solid rgb(204, 204, 204)' }
              : {}),
          }}
        >
          <TopAppBarRow style={{ height: '100%' }}>
            <TopAppBarSection alignStart style={{ height: '100%' }}>
              {wlVar('logo_href') ? (
                <a href={wlVar('logo_href')} data-source="header" target="_blank">
                  <PaddedLogo src={wlVar('logo_url')} style={{ height: '75px' }} />
                </a>
              ) : (
                <PaddedLogo src={wlVar('logo_url')} style={{ height: '75px' }} />
              )}
            </TopAppBarSection>
            <TopAppBarSection alignEnd style={{ alignItems: 'center' }}>
              {this.state.useMenuIcon && numberOfLinks > 1 ? (
                <MenuAnchor>
                  <Menu open={this.state.menuIsOpen} onClose={evt => this.setState({ menuIsOpen: false })}>
                    {wlVar('link_label_extra2') &&
                      wlVar('link_href_extra2') && (
                        <MenuItem onClick={() => newWindow(wlVar('link_href_extra2'), 'header')}>
                          {wlVar('link_label_extra2')}
                        </MenuItem>
                      )}
                    {wlVar('link_label_extra1') &&
                      wlVar('link_href_extra1') && (
                        <MenuItem onClick={() => newWindow(wlVar('link_href_extra1'), 'header')}>
                          {wlVar('link_label_extra1')}
                        </MenuItem>
                      )}
                    {wlVar('link_label_services') &&
                      wlVar('link_href_services') && (
                        <MenuItem onClick={() => newWindow(wlVar('link_href_services'), 'header')}>
                          {wlVar('link_label_services')}
                        </MenuItem>
                      )}
                    {wlVar('link_label_consult') &&
                      wlVar('link_href_consult') && (
                        <MenuItem onClick={() => newWindow(wlVar('link_href_consult'), 'header')}>
                          {wlVar('link_label_consult')}
                        </MenuItem>
                      )}
                  </Menu>
                  <Icon
                    onClick={evt => this.setState({ menuIsOpen: !this.state.menuIsOpen })}
                    style={{ width: '24px', height: '24px', marginRight: '15px', cursor: 'pointer' }}
                    use="menu"
                  />
                </MenuAnchor>
              ) : (
                <Fragment>
                  {wlVar('link_label_extra2') &&
                    wlVar('link_href_extra2') && (
                      <Button
                        className="mr-2"
                        theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
                        onClick={() => newWindow(wlVar('link_href_extra2'), 'header')}
                      >
                        {wlVar('link_label_extra2')}
                      </Button>
                    )}
                  {wlVar('link_label_extra1') &&
                    wlVar('link_href_extra1') && (
                      <Button
                        className="mr-2"
                        theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
                        onClick={() => newWindow(wlVar('link_href_extra1'), 'header')}
                      >
                        {wlVar('link_label_extra1')}
                      </Button>
                    )}
                  {wlVar('link_label_services') &&
                    wlVar('link_href_services') && (
                      <Button
                        className="mr-2"
                        theme={wlVar('white_header') ? 'text-primary-on-light' : 'on-primary'}
                        onClick={() => newWindow(wlVar('link_href_services'), 'header')}
                      >
                        {wlVar('link_label_services')}
                      </Button>
                    )}
                  {wlVar('link_label_consult') &&
                    wlVar('link_href_consult') && (
                      <Button
                        theme="secondary-bg on-secondary"
                        onClick={() => newWindow(wlVar('link_href_consult'), 'header')}
                      >
                        {wlVar('link_label_consult')}
                      </Button>
                    )}
                </Fragment>
              )}
            </TopAppBarSection>
          </TopAppBarRow>
        </TopAppBar>
        <TopAppBarShim />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.user.user,
  };
}

export default withRouter(connect(mapStateToProps)(Header));
